<template>
  <v-main class="pt-0">
    <Impressum ref="dlgImpressum"></Impressum>
    <Datenschutz ref="dlgDatenschutz"></Datenschutz>
    <Nutzung ref="dlgNutzung"></Nutzung>
    <v-container fluid class="pt-0 marigntoptoolbar">
      <v-row wrap>
        <v-col xs="12" class="pt-0">
          <v-card class="bgstart hidden-md-and-up" height="898" flat>
            <v-img src="/static/examenis_startxs.png" max-height="400" height="400" contain class="startpic mt-10">
            </v-img>
          </v-card>
          <v-card class="bgstart hidden-sm-and-down" height="698" flat>
            <v-img src="/static/examenis_start.png" height="768" class="startpic">
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="5" class="textstart pt-10">
          <v-card flat color="transparent" class="hidden-md-and-up">
            <v-card-text class="text-h4 font-weight-light text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="45"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
              Es war noch nie so einfach <br><br>
              <span class="font-weight-bold text-h3 examenistext">examenis</span> <br><br>
              <span class="text-h6 font-weight-light">
            Die intelligente Softwarelösung  <br>für moderne Prüfungen und Umfragen
              </span>
            </v-card-text>
            <v-card-text class="text-h4 font-weight-light text-center mt-6" v-if="false">
              <v-btn color="#043073" class="text-none" outlined>
                examenis in 30 Sekunden
              </v-btn>
            </v-card-text>
          </v-card>
          <v-card flat color="transparent" class="hidden-sm-and-down mt-16">
            <v-card-text class="text-h4 font-weight-light text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="45"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
              Es war noch nie so einfach <br><br>
              <span class="font-weight-bold text-h3 examenistext">examenis</span> <br><br>
              <span class="text-h6 font-weight-light">
            Die intelligente Softwarelösung  <br>für moderne Prüfungen und Umfragen
              </span>
            </v-card-text>
            <v-card-text class="text-h4 font-weight-light text-center mt-6" v-if="false">
              <v-btn color="#043073" class="text-none" outlined>
                examenis in 30 Sekunden
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col xs="12">
          <v-card class="text-center" color="transparent" flat>
            <v-card-text class="text-h6 font-weight-light examenistext">
              &bdquo;Es war noch nie so einfach&ldquo;
            </v-card-text>
            <v-card-text class="text-h4 font-weight-bold examenistext">
              In kürzester Zeit Prüfungen anlegen und auswerten
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="6">
          <v-card
              class="mx-auto"
              flat
          >
            <v-card-text class="text-h5 text-left examenistext">
              Fragen erstellen
            </v-card-text>
            <v-card-text class="subtitle-1 text-left examenistext font-weight-light">
              Jede Prüfung beginnt mit dem Anlegen von Fragen.
              Nachdem Sie sich zwischen den verschieden Fragetypen entschieden und ein Fach gewählt haben,
              können Sie im Frage-Editor mit Ihrer Frage und Antworten starten.
              Im Frage-Editor werden ebenfalls die richtigen Antworten hinterlegt und die jeweiligen Punkte vergeben.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xs="12" sm="12" md="6" order-sm="first">
          <v-card
              class="mx-auto"
              flat
              max-width="400"
          >
            <v-img
                class="align-top"
                src="/static/examenis_Homepage_eins.png"
            >
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" md="6">
          <v-card
              class="mx-auto"
              flat
          >
            <v-card-text class="text-h5 text-left examenistext">
              Bogen / Prüfungen erstellen
            </v-card-text>
            <v-card-text class="subtitle-1 text-left examenistext font-weight-light">
              Ihre angelegten Fragen werden in einem Bogen von Ihnen zusammengestellt.
              Alle Fragen ausgewählt, richtig sortiert und zusammenhängende Fragen richtig zugeordnet?
              Dann wandeln Sie Ihren Bogen zur Prüfung, fügen Teilnehmer hinzu und stellen die Prüfung online oder drucken sie aus.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xs="12" md="6">
          <v-card
              class="mx-auto"
              flat
              max-width="400"
          >
            <v-img
                class="align-top"
                src="/static/examenis_Homepage_zwei.png"
            >
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mb-10">
        <v-col xs="12" sm="12" md="6">
          <v-card
              class="mx-auto"
              flat
          >
            <v-card-text class="text-h5 text-left examenistext">
              Prüfung durchführen
            </v-card-text>
            <v-card-text class="subtitle-1 text-left examenistext font-weight-light">
              Mit den Zugangsdaten kann der Prüfling an der online Prüfung teilnehmen.
              Sie können entscheiden, zu welchem Zeitpunkt die Prüfung online geht und
              wie lange die Prüflinge Zeit mit der Bearbeitung haben.
              Sie möchten lieber eine Papierbasierte Prüfung durchführen.
              Kein Problem, drucken Sie die Prüfung aus.
              Nach der Durchführung, brauchen Sie die Antwortbögen nur einscannen und mit examenis auswerten lassen.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col xs="12" sm="12" md="6" order-sm="first">
          <v-card
              class="mx-auto"
              flat
              max-width="450"
          >
            <v-img
                class="align-top"
                src="/static/examenis_Homepage_drei_pa.png"
            >
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="justify-center mt-16" wrap>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              breites Spektrum an Fragetypen
            </v-card-text>
            <v-card-text class="text-h6 text-left font-weight-light">
              <ul>
                <li>
                  Single- und Multiple Choice-Fragen
                </li>
                <li>
                  Zuordnungs-, Umordnungs- und Vergleichsaufgaben
                </li>
                <li>
                  Ergänzungs-, Begriffs- und Textaufgaben
                </li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              LaTeX
            </v-card-text>
            <v-card-text class="text-h6 left font-weight-light">
              Mit der Einbindung von LaTeX ist es ein leichtes komplizierte Formeln darzustellen.
            </v-card-text>
            <v-img src="/static/Formel.png" width="300" class="ml-6"></v-img>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              Digital und Analog
            </v-card-text>
            <v-card-text class="text-h6 text-left font-weight-light">
              <ul>
                <li>Prüfungen und Umfragen online</li>
                <li>papierbasiert durch Scanner-Schnittstelle</li>
              </ul>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              LDAP Anbindung
            </v-card-text>
            <v-card-text class="text-h6 text-left font-weight-light">
              Verknüpfen Sie examenis mit Ihrer LDAP Authentifizierung.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              Notenschlüssel
            </v-card-text>
            <v-card-text class="text-h6 text-center font-weight-light">
              Definieren Sie Ihre eigenen Notenschlüssel.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" xs="12" sm="8" lg="4" class="my-5">
          <v-card height="380">
            <v-card-text class="text-center">
              <v-avatar
                  color="transparent"
                  tile
                  size="100"
                  class="mt-n16"
              >
                <v-img src="/static/examenis_x.png"></v-img>
              </v-avatar>
            </v-card-text>
            <v-card-text class="text-h5 text-center">
              Analyse
            </v-card-text>
            <v-card-text class="text-h6 text-left font-weight-light">
              Waren die Fragen zu einfach? Werten Sie Ihre Fragen aus.
              Wie viele Teilnehmer kannten die richtige Antwort und wie war die Frage zum Vergleich zu anderen Fragen.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="mt-10 marigntoptoolbar">
      <v-row wrap class="mt-5">
        <v-col xs="12" class="pt-16">
          <v-card class="positioneins" height="898" flat>
            <v-img src="/static/Pic_examenis-xs.png" max-height="500" contain class="animation-element slide-left testimonial hidden-md-and-up mt-10">
            </v-img>
            <v-img src="/static/Pic_examenis.png" max-height="768" width="auto" class="animation-element slide-left testimonial hidden-sm-and-down">
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="hidden-sm-and-down">
        <v-col xs="12" sm="5" md="6">
        </v-col>
        <v-col xs="12" sm="7" md="6" class="textstart">
          <v-card flat color="transparent">
            <v-card-text class="text-h4 font-weight-light text-center">
              Egal wo, egal wann <br><br>
              <span class="font-weight-bold text-h3 examenistext">examenis</span> <br><br>
              <span class="text-h6 font-weight-light">
           Durch examenis haben Sie keinerlei Datenverluste mehr, denn die gesamten Daten werden auf digitaler Ebene archiviert und sind zu jeder Zeit abrufbar.
                  Die ökonomische Filterfunktion hilft Ihnen dabei Ihre archivierten und aktuellen Dokumente schneller und einfacher zu finden.
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="hidden-md-and-up">
        <v-col xs="12" sm="12" class="textstart">
          <v-card flat color="transparent">
            <v-card-text class="text-h4 font-weight-light text-center mt-16">
              Egal wo, egal wann <br><br>
              <span class="font-weight-bold text-h3 examenistext">examenis</span> <br><br>
              <span class="text-h6 font-weight-light">
           Durch examenis haben Sie keinerlei Datenverluste mehr, denn die gesamten Daten werden auf digitaler Ebene archiviert und sind zu jeder Zeit abrufbar.
                  Die ökonomische Filterfunktion hilft Ihnen dabei Ihre archivierten und aktuellen Dokumente schneller und einfacher zu finden.
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-card flat>
            <v-card-text class="text-h4 text-center font-weight-light hidden-xs-only">
              examenis in <span class="text-h1 examenistext">5</span> Schritten
            </v-card-text>
            <v-card-text class="text-h5 text-center font-weight-light hidden-sm-and-up">
              examenis in <span class="text-h2 examenistext">5</span> Schritten
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-timeline :dense="$vuetify.breakpoint.smAndDown">
            <v-timeline-item
                color="#043073"
                fill-dot
                right
            >
              <v-card>
                <v-card-title class="examenisbg">
                  <h1
                      class="white--text font-weight-bold mr-4"
                  >1
                  </h1>
                  <h2 class="headline white--text font-weight-light hidden-sm-and-down">
                    Fragen erstellen / Editor
                  </h2>
                  <h2 class="text-h6 white--text font-weight-light hidden-md-and-up">
                    Fragen erstellen / Editor
                  </h2>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-card flat>
                        <v-card-text class="pl-6 pb-0 subtitle-1 font-weight-light greytextexamenis">
                          <ul>
                            <li> Verwendung geschlossener Fragetypen</li>
                            <li>	Verwendung offener Fragen </li>
                            <li>	 Verwendung von Grafiken und
                              Multimedia in Fragen</li>
                            <li>	 Anzeige von Veränderungsdaten der
                              Fragen (letzte Änderung/Verwendung,
                              Häufigkeit Verwendung)</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                      <v-expansion-panels flat>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>
                            <span class="examenistext">Mehr...</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card-text class="pa-0 subtitle-1 font-weight-light greytextexamenis">
                              <ul>
                                <li> Versionierung der Fragen </li>
                                <li>	 Erfassung von Kommentaren zu Fragen </li>
                                <li>	 Einordnung der Fragen in Teilgebiete und
                                  Fachgebiete (Mehrfachfiltersystem) </li>
                                <li> Kopierfunktion für Fragen </li>
                                <li>	 Individuelle, freie Platzierung / Anordnung
                                  von Frageelementen (Text, Absatz,
                                  Ausrichtung)</li>
                                <li>	 Zeichen- und Absatzformatierung von
                                  Frageelementen</li>
                                <li> Verwendung von eigenen
                                  HTML Elementen / Code</li>
                                <li>	 Individuelle, freie Gestaltung /
                                  Design der Fragen</li>
                                <li> Umfangreiche Bepunktungssysteme
                                  pro Frage</li>
                                <li> Zufallsverteilte Reihenfolge der
                                  Antwortalternativen bei geschlossenen
                                  Fragen</li>
                                <li>	 Verwendung von LaTex-Formeln
                                  und –ausdrücken</li>
                              </ul>
                            </v-card-text>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
                color="#043073"
                fill-dot
                left
            >
              <v-card>
                <v-card-title class="examenisbg">
                  <h1
                      class="white--text font-weight-bold mr-4"
                  >2
                  </h1>
                  <h2 class="headline white--text font-weight-light hidden-sm-and-down">
                    Test / Klausur erstellen
                  </h2>
                  <h2 class="text-h6 white--text font-weight-light hidden-md-and-up">
                    Test / Klausur erstellen
                  </h2>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-card flat>
                        <v-card-text class="pl-6 pb-0 subtitle-1 font-weight-light greytextexamenis">
                          <ul>
                            <li>Anzeige von Veränderungsdaten der
                              Tests (letzte Änderung/Verwendung,
                              Häufigkeit Verwendung)</li>
                            <li>Voransicht / Vorschau des Tests /
                              der Testfragen</li>
                            <li>Einfache Umordnung der Fragen
                              innerhalb eines Tests</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                      <v-expansion-panels flat>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>
                            <span class="examenistext">Mehr...</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card-text class="pa-0 subtitle-1 font-weight-light greytextexamenis">
                              <ul>
                                <li>Kopierfunktion für Tests</li>
                                <li>Suchfunktion von Tests nach
                                  verschiedenen Kriterien (Autor, ID, Fach,
                                  Teilgebiet, Schlagwort)</li>
                                <li>Einordnung der Tests in Teilgebiete und
                                  Fachgebiete (Mehrfachfiltersystem)</li>
                                <li>Optionale Zeitvorgaben für die
                                  Durchführung der Tests (online)</li>
                                <li>Optionale Mehrfachanmeldung an einem
                                  Test je Teilnehmer (online)</li>
                                <li>Vier-Augen-Prinzip / Freigabefunktion für
                                  erstellte Fragen / Prüfungen</li>
                                <li>Zufallsgesteuertes Mischen der
                                  Frageanordnung</li>
                                <li>Fixieren der Positionen von Klausurfragen
                                  beim Mischen</li>
                                <li>Integrierbarkeit von zusätzlichen
                                  Prüfungspunkten zur Gesamtnote</li>
                              </ul>
                            </v-card-text>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
                color="#043073"
                fill-dot
                right
            >
              <v-card>
                <v-card-title class="examenisbg">
                  <h1
                      class="white--text font-weight-bold mr-4"
                  >3
                  </h1>
                  <h2 class="headline white--text font-weight-light hidden-sm-and-down">
                    Prüfung durchführen
                  </h2>
                  <h2 class="text-h6 white--text font-weight-light hidden-md-and-up">
                    Prüfung durchführen
                  </h2>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-card flat>
                        <v-card-text class="pl-6 pb-0 subtitle-1 font-weight-light greytextexamenis">
                          <ul>
                            <li>Optionale Nachbearbeitung von
                              Teilnehmern</li>
                            <li>Importieren von Teilnehmern aus
                              bestehenden Datenbanken</li>
                            <li>Personifizierte Testdurchführung
                              PIN/TAN (online)</li>
                            <li>Bereitstellung der Teilnehmerzugänge
                              per Ausdruck (online)</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                      <v-expansion-panels flat>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>
                            <span class="examenistext">Mehr...</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card-text class="pa-0 subtitle-1 font-weight-light greytextexamenis">
                              <ul>
                                <li>Detaillierte Teilnehmerdaten online
                                  einsehbar</li>
                                <li>Individuelles Sperren einzelner Teilnehmer
                                  (online)</li>
                                <li>Gemischte Prüfungsform möglich
                                  (papier- und EDV-gestützt)</li>
                                <li>Automatisierte Identifizierung der
                                  Antwortbögen durch Barcode</li>
                                <li>Automatisierte Identifizierung der
                                  Teilnehmer durch Kenncode</li>
                                <li>Getrennte Erstellung von
                                  Lernfortschrittskontrollen
                                  (Übungsklausuren)</li>
                                <li>Lokale Durchführung von
                                  Übungsklausuren</li>
                                <li>Multilingualität bei Durchführung der
                                  Prüfungen</li>
                                <li>Erweiterte Personendaten für Teilnehmer
                                  verwalten</li>
                              </ul>
                            </v-card-text>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
                color="#043073"
                fill-dot
                left
            >
              <v-card>
                <v-card-title class="examenisbg">
                  <h1
                      class="white--text font-weight-bold mr-4"
                  >4
                  </h1>
                  <h2 class="headline white--text font-weight-light hidden-sm-and-down">
                    Datenauswertung
                  </h2>
                  <h2 class="text-h6 white--text font-weight-light hidden-md-and-up">
                    Datenauswertung
                  </h2>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-card flat>
                        <v-card-text class="pl-6 pb-0 subtitle-1 font-weight-light greytextexamenis">
                          <ul>
                            <li>Test jederzeit auswertbar</li>
                            <li>Automatisches Einlesen von
                              papierbasierten Antwortbögen per
                              Dokumentenscanner</li>
                            <li> Sichere Archivierung von Prüfungen</li>
                            <li> Grafische Ergebnisdarstellung</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                      <v-expansion-panels flat>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>
                            <span class="examenistext">Mehr...</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card-text class="pa-0 subtitle-1 font-weight-light greytextexamenis">
                              <ul>
                                <li>Übersicht der einzelnen
                                  Antwortergebnisse pro Frage</li>
                                <li>Angabe der Durchschnittsnoten /
                                  der Durchschnittspunktzahl</li>
                                <li>Berechnung wichtiger statistischer
                                  Kennwerte (Schwierigkeit, Trennschärfe)</li>
                                <li>Heben- und Senkenfunktionalität
                                  der Ergebnisse</li>
                                <li>Individuelle Eingabe und Bearbeitung
                                  des Notenschlüssels</li>
                                <li>Automatischer Export der Daten in
                                  andere Datenformate</li>
                                <li>Evaluationsergebnisse von
                                  Prüfungen einbindbar</li>
                              </ul>
                            </v-card-text>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>

            <v-timeline-item
                color="#043073"
                fill-dot
                right
            >
              <v-card>
                <v-card-title class="examenisbg">
                  <h1
                      class="white--text font-weight-bold mr-4"
                  >5
                  </h1>
                  <h2 class="headline white--text font-weight-light hidden-sm-and-down">
                    Verwaltung / Integration
                  </h2>
                  <h2 class="text-h6 white--text font-weight-light hidden-md-and-up">
                    Verwaltung / Integration
                  </h2>
                </v-card-title>
                <v-container>
                  <v-row>
                    <v-col
                        cols="12"
                    >
                      <v-card flat>
                        <v-card-text class="pl-6 pb-0 subtitle-1 font-weight-light greytextexamenis">
                          <ul>
                            <li>Benutzergruppenverwaltung</li>
                            <li>Internes Kommunikationssystem
                              (bei Fehlern, Meldungen, Hinweise)</li>
                            <li>Keine lokale Softwareinstallation
                              notwendig</li>
                            <li>Nutzung über herkömmliche Webbrowser</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                      <v-expansion-panels flat>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>
                            <span class="examenistext">Mehr...</span>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-card-text class="pa-0 subtitle-1 font-weight-light greytextexamenis">
                              <ul>
                                <li>Assistent für alternative Bedienung
                                  des Systems</li>
                                <li>Anbindung an bestehende
                                  Authentifizierungssysteme möglich</li>
                                <li>Automatisches zeitgesteuertes Löschen
                                  von alten Teilnehmer-Antworten</li>
                              </ul>
                            </v-card-text>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-card flat class="text-center">
        <v-card-text class="text-h4">
          Bereit für das Kreuz an der richtigen Stelle?
        </v-card-text>
        <v-img src="/static/examenis_mail.png" max-height="400" contain>
        </v-img>
      </v-card>
      <v-row class="justify-center">
        <v-col
            cols="12"
        >
          <v-card class="text-center" flat>
            <v-card-text class="text-h5">
              Wir beraten Sie gerne - schreiben Sie uns eine E-Mail
            </v-card-text>
            <v-btn href="mailto:info@edologic.de" class="text-none mt-8" color="#043073" outlined>Jetzt E-Mail schreiben</v-btn>
            <!--<v-card-subtitle class="mb-6">
              Ihr direkter Kontakt zu uns ist nur wenige Klicks entfernt:<br>
              Nutzen Sie unser Kontaktformular oder schreiben Sie uns eine
              <a href="mailto:info@edologic.de">E-Mail</a>
            </v-card-subtitle>-->
            <!--
            <v-row class="justify-center">
              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-select
                    v-model="anrede"
                    label="Anrede"
                    :items="anrede"
                    outlined
                    color="#043073"
                    clearable
                    shaped
                ></v-select>
              </v-col>
              <v-col cols="12" xs="12" md="3" class="hidden-xs-only py-0">
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-text-field
                    v-model="first"
                    label="Vorname"
                    outlined
                    color="#043073"
                    shaped
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-text-field
                    v-model="last"
                    label="Nachname"
                    outlined
                    color="#043073"
                    shaped
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center">
              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-text-field
                    v-model="number"
                    label="Telefonnummer"
                    outlined
                    color="#043073"
                    shaped
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-text-field
                    v-model="mail"
                    label="E-Mail"
                    outlined
                    color="#043073"
                    shaped
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="justify-center">

              <v-col cols="12" xs="12" md="3" class="py-0">
                <v-checkbox v-model="checkbox" color="#043073">
                  <template v-slot:label>
                    <div>
                      Ich kenne und akzeptiere die
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                              target="_blank"
                              href="https://www.edologic.de"
                              @click.stop
                              v-on="on"
                          >
                            Datenschutzerklärung.
                          </a>
                        </template>
                        Im neuem Fenster öffnen
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" xs="12" md="3">
                <v-btn block color="#043073" class="text-none" dark outlined large>
                  Absenden
                </v-btn>
              </v-col>
            </v-row>
            -->
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col xs="12" class="pt-0">
          <v-card height="400" flat>
            <v-img src="/static/examenis_zitat.png" height="600">
              <v-card-text class="text-center mt-16 text-h2 examenistext">
                Stimmen zu examenis
              </v-card-text>
              <v-row class="justify-center mt-n16">
                <v-col cols="12" xs="12" sm="10" md="6">
                  <v-card-text class="mt-n10">
                    <v-carousel
                        cycle
                        height="400"
                        hide-delimiter-background
                        show-arrows-on-hover
                    >
                      <v-carousel-item
                          v-for="(slide, i) in slides"
                          :key="i"
                      >
                        <v-sheet
                            height="100%"
                            color="transparent"
                            class="pa-3 text-center"
                        >
                          <v-row
                              class="fill-height hidden-xs-only mt-n15"
                              align="center"
                              justify="center"
                          >
                            <div class="text-h5 examenistext mb-4">
                              {{ slide.title }}
                            </div>
                            <span class="examenistext text-h6 hidden-xs-only mt-n6" style="top: 320px; position: absolute">
                              {{ slide.name }}
                            </span>
                          </v-row>
                          <v-row
                              class="fill-height hidden-sm-and-up mt-n16"
                              align="center"
                              justify="center"
                          >
                            <div class="text-h5 examenistext mb-4 mt-n8 mx-5 text-center">
                              {{ slide.title }}
                            </div>
                            <span class="examenistext text-h6 hidden-sm-and-up" style="top: 280px; position: absolute">
                            {{ slide.name }}
                          </span>
                          </v-row>
                        </v-sheet>
                      </v-carousel-item>
                    </v-carousel>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col class="pb-0">
          <v-card  flat class="diagonalgrey" tile>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0 pb-0">
          <v-card color="#043073" flat tile height="450">
            <v-container fluid>
              <v-row
                  justify="center"
                  wrap
              >
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-card color="transparent" flat>
                    <v-row justify="center">
                      <v-img src="static/logo_examenis_neg.png" max-height="40px" max-width="155" class="mt-2 hidden-md-and-up ml-n6"/>
                    </v-row>
                    <v-row justify="center">
                      <v-img src="static/logo_examenis_neg.png" max-height="40px" max-width="155" class="mt-2 hidden-sm-and-down"/>
                      <span class="white--text ml-5 mt-5 text-body-2">Ein Produkt der edologic GmbH
                                        <br> <br> <br>
                                         <span class="font-weight-bold">edologic GmbH</span>
                                            <br>
                                            In der Hardt 3<br>
                                            42399 Wuppertal<br><br>
                                            <a href="https://www.edologic.de" style="text-decoration: none; color: white">www.edologic.de</a><br>
                                            <a href="mailto:info@edologic.de" style="text-decoration: none; color: white">info@edologic.de</a>
                                        </span>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" xs="12" md="3">
                  <v-card color="transparent" flat>
                    <v-row justify="center">
                      <v-card color="transparent" flat width="250" class="mt-6  ml-9">
                        <v-row justify="start" class="ml-5">
                           <span class="white--text text-body-2">
                            <span class="font-weight-bold">Informationen</span>
                              <br><br>
                                <v-btn text small dark class="text-none ml-n3" @click="openImpressum"> Impressum</v-btn><br>
                                <v-btn text small dark class="text-none ml-n3" @click="openNutzung"> Nutzungsbedingungen</v-btn><br>
                                <v-btn text small dark class="text-none ml-n3" @click="openDatenschutz"> Datenschutz</v-btn>
                           </span>
                        </v-row>
                      </v-card>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-footer color="#ffc107" class="pa-3 text-caption"   id="contactRef" ref='contactRef'>
        <v-spacer></v-spacer>
        <div>&copy; {{ new Date().getFullYear() }} edologic. All Rights Reserved.</div>

      </v-footer>
      <CookieConsent style="background-color: white" button-text="Okay">
        <div class="text-h6 bluetext">
          Cookie Einstellung
        </div><br>
        <div class="mb-6">
          Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die Benutzererfahrung effizienter zu gestalten, bestimmte Funktionen bereitzustellen oder um bestimmte Auswertungen zu ermöglichen. Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt notwendig sind.
          <!--
          Diese Webseite verwendet Cookies, um Ihnen den bestmöglichen Service zu gewährleisten. Wenn Sie auf der Seite weitersurfen stimmen Sie der Cookie-Nutzung zu. Weitere Informationen
          -->
        </div>
        <template v-slot:link>
          <div>
            <v-btn depressed small text @click="openDatenschutz" class="pa-2">Weitere Informationen</v-btn>

          </div>
        </template>
      </CookieConsent>
    </v-container>
  </v-main>
</template>

<script>
import CookieConsent from "v-cookie-consent"
import $ from "jquery"
import Impressum from "./Impressum";
import Datenschutz from "./Datenschutz";
import Nutzung from "./Nutzung";
export default {
  name: 'Home',
  components: {Nutzung, Datenschutz, Impressum, CookieConsent},
  data () {
    return {
      anrede: ['Frau','Herr','Keine Angabe'],
      checkbox: false,
      slides: [
        {
          title: 'Das Layout der Fragebögen ist hervorragend',
          name: 'Dozent FH Dortmund'
        },
        {
          title: 'Es ist wirklich einfach',
          name: 'Feuerwehrschule Bruchsal'
        },
        {
          title: 'Die Onlineprüfung - Funktionalität ist überzeugend',
          name: ''
        },
        {
          title: 'Die Antwortbögen im Browser zu erfassen ist sehr komfortabel',
          name: ''
        }
      ]
    }
  },
  methods: {
    openImpressum: function () {
      this.$refs.dlgImpressum.opendialog()
    },
    openDatenschutz: function () {
      this.$refs.dlgDatenschutz.opendialog()
    },
    openNutzung: function () {
      this.$refs.dlgNutzung.opendialog()
    },
  },
  mounted () {

    //window and animation items
    var animation_elements = $.find('.animation-element');
    var web_window = $(window);

    //check to see if any animation containers are currently in view
    function check_if_in_view() {
      //get current window information
      var window_height = web_window.height();
      var window_top_position = web_window.scrollTop();
      var window_bottom_position = (window_top_position + window_height);

      //iterate through elements to see if its in view
      $.each(animation_elements, function() {

        //get the element sinformation
        var element = $(this);
        var element_height = $(element).outerHeight();
        var element_top_position = $(element).offset().top;
        var element_bottom_position = (element_top_position + element_height);

        //check to see if this current container is visible (its viewable if it exists between the viewable space of the viewport)
        if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
          element.addClass('in-view')
        } else {
          element.removeClass('in-view')
        }
      });

    }
    //on or scroll, detect elements in view
    $(window).on('scroll resize', function() {
      check_if_in_view()
    })
    //trigger our scroll event on initial load
    $(window).trigger('scroll')

  }
}
</script>

<style scoped>

</style>
